import {Component, Input} from '@angular/core';
import {BerlinWetterbericht} from '../../../../../../../model/vorhersagen/rbb-document';
import {FirebaseService} from '../../../../../../../service/firebase/firebase.service';
import {take} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-berlin-bericht',
  templateUrl: './berlin-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class BerlinBerichtComponent {

  @Input()
  berlinWetterbericht?: BerlinWetterbericht;

  aktuelleTemperaturenGlobalId = ['M_DWD_W_010_384', 'M_MG_S_6510394', 'M_MG_S_6510388'];

  isLoading = false;

  constructor(private firebaseService: FirebaseService, private snackbar: MatSnackBar) {
    this.loadAktuelleTemperaturen();
  }

  private loadAktuelleTemperaturen() {

    this.isLoading = true;
    this.firebaseService.getMesswerteStuendlichByID(this.aktuelleTemperaturenGlobalId, 'DWDMG_DEUTSCHLAND')
      .pipe(take(1))
      .subscribe(messwertPakete => {
        this.berlinWetterbericht.aktuelleTemperaturen = {bezirk_ortsteil: new Array<{ name: string; wert: number }>()};
        for (const value of messwertPakete) {
          if (this.aktuelleTemperaturenGlobalId.includes(value.ort.id)) {
            this.berlinWetterbericht.aktuelleTemperaturen.bezirk_ortsteil.push({
              name: value.ort.name,
              wert: value.messwerte.lufttemperatur.messwert
            });
          }
        }
      }, error => {
        this.snackbar.open(`ERROR: Konnte aktuelle Temperaturen nicht laden ${error}`);
      }).add(() => this.isLoading = false);
  }

  getAktuelleTemperaturenSortedByOrtsteilNameAscending(): Array<{ name: string, wert: number }> {
    return this.berlinWetterbericht?.aktuelleTemperaturen?.bezirk_ortsteil.sort((bezirk1, bezirk2) => bezirk1.name.localeCompare(bezirk2.name));
  }
}
